export default {
      id: "huge-document-info-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.25bf3227.svg#huge-document-info",
      toString: function () {
        return this.url;
      }
    }